var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$store.getters['user/isLister'])?_c('div',[_c('a',{staticClass:"interactive",class:_vm.classes,on:{"click":_vm.handleClick}},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }